if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.personalization = this.form.querySelector('[data-wwk-personalization]');
        if (this.personalization) {
          this.form.querySelector('[name=id]').addEventListener('change', () => this.syncPersonalization());
          this.personalization.addEventListener('input', (event) => {
            if (event.target.matches('input, textarea, select')) {
              event.target.setCustomValidity('');
              event.target.removeAttribute('aria-invalid');
            }
          });
          this.syncPersonalization();
        }
      }

      syncPersonalization() {
        if (!this.personalization) return;
        const inactiveVariants = this.personalization.dataset.inactiveVariants.split(',');
        const inactive = inactiveVariants.includes(this.form.querySelector('[name=id]').value);
        this.personalization.querySelector('[data-wwk-fields]').hidden = inactive;
        this.personalization.querySelector('[data-wwk-inactive]').hidden = !inactive;
        this.personalization.querySelectorAll('input, textarea, select').forEach((field) => {
          field.disabled = inactive;
          field.required = !inactive && field.hasAttribute('data-wwk-required');
          if (inactive) {
            field.setCustomValidity('');
            field.removeAttribute('aria-invalid');
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.syncPersonalization();
        if (this.personalization) {
          this.personalization.querySelectorAll('input, textarea, select').forEach((field) => {
            if (field.disabled) return;
            field.value = field.value.trim();
            field.setCustomValidity(field.required && !field.value ? this.personalization.dataset.requiredMessage : '');
            if (field.dataset.wwkMaxLines && field.value.split(/\r?\n/).filter((line) => line.trim()).length > Number(field.dataset.wwkMaxLines)) {
              field.setCustomValidity(this.personalization.dataset.maxLinesMessage);
            }
            if (!field.checkValidity()) field.setAttribute('aria-invalid', 'true');
            else field.removeAttribute('aria-invalid');
          });
          if (!this.form.reportValidity()) return;
        }
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (this.dataset.wwkNetworkError) this.handleErrorMessage(this.dataset.wwkNetworkError);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
